import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
// import { FlexLayoutModule } from '@angular/flex-layout';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatRippleModule } from '@angular/material/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDialogModule } from '@angular/material/dialog';
import { BsrMobileComponent, editName, welcomeDialog } from './bsr-mobile/bsr-mobile.component';
import { WelcomeMessagePipe } from './bsr-mobile/welcome-message.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
// import { CKEditorModule } from 'ckeditor4-angular';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import {  MatSelectModule } from '@angular/material/select';
import { HammerModule } from '@angular/platform-browser';
// import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {  MatProgressBarModule } from '@angular/material/progress-bar';
import { DragulaModule } from 'ng2-dragula';
import {  MatListModule } from '@angular/material/list';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import {  MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import {  MatRadioModule } from '@angular/material/radio';
import { CdkTableModule } from '@angular/cdk/table';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTreeModule } from '@angular/cdk/tree';
import { A11yModule } from '@angular/cdk/a11y';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
// import {BmxCreatorComponent} from './bmx/components/bmx-creator/bmx-creator.component'

import { CommonModule } from '@angular/common';
// import { TinderComponent } from './bmx/bmx-creator/survey-creation-design/templates/tinder/tinder.component';
import { QuillModule } from 'ngx-quill';

export function loadEcharts() {
  return import('echarts');
}


export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: 'fbcbd5db-c816-4ffb-8310-316cf7781c45',
      authority: 'https://login.microsoftonline.com/f010ce16-e13d-4c24-87af-3a1eb4d11de6',
      redirectUri: 'http://localhost:4200',
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
  });
}
@NgModule({ declarations: [
        AppComponent,
        // LoginComponent,
        BsrMobileComponent,
        editName,
        welcomeDialog,
        WelcomeMessagePipe,
        // BmxComponent,
        // BmxCreatorComponent,
        // BmxCreatorComponent,
        // SafePipe,
        // OrderDasboardComponent
    ],
    bootstrap: [AppComponent], imports: [CommonModule,
        BrowserModule,
        HammerModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatSlideToggleModule,
        MatRippleModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatButtonModule,
        MatInputModule,
        MatDatepickerModule,
        MatBadgeModule,
        MatCardModule,
        MatDialogModule,
        MatIconModule,
        // FlexLayoutModule,
        // DragDropModule,
        MatTooltipModule,
        MatGridListModule,
        MatSidenavModule,
        CKEditorModule,
        FormsModule,
        MatTableModule,
        // HotkeyModule.forRoot(),
        MatSliderModule,
        MatTabsModule,
        // DeviceDetectorModule,
        //AngularDateTimePickerModule,
        MatDatepickerModule,
        MatSelectModule,
        MatRadioModule,
        MatNativeDateModule,
        MatProgressBarModule,
        NgxChartsModule,
        // AngularEditorModule,
        DragulaModule.forRoot(),
        MatListModule,
        // NgxEchartsModule.forRoot({ echarts: loadEcharts }),
        MatSnackBarModule,
        MatSortModule,
        MatPaginatorModule,
        DragDropModule,
        ScrollingModule,
        CdkTableModule,
        CdkTreeModule,
        A11yModule,
        MatAutocompleteModule,
        QuillModule], providers: [
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 1000 } },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }

